import React from "react";
import {cssArray, CSSType} from "../../utils";
import {root, rootFullWidth} from "./styles";

export type InputProps = React.InputHTMLAttributes<HTMLInputElement> &{
    variant?: "primary"
    fullWidth?: boolean;
    overrideCss?: CSSType;
}

export const Input: React.FC<InputProps> = ({
    children,
    overrideCss,
    variant = "primary",
    fullWidth,
    ...rest
    }) => {
    return(
        <input css={[root, fullWidth && rootFullWidth, ...cssArray(overrideCss)]} {...rest}>
            {children}
        </input>
    )
}

export default Input;